import startCase from 'lodash/startCase';
import { capitalize, getCultureLocale, getObjectiveLocale } from './HelperUtils';
String.prototype.h5locale = function () {
    const appType = localStorage.getItem('appType');
    const parsedAppType = appType === 'null' ? null : JSON.parse(appType);
    return parsedAppType === 'culture'
        ? getCultureLocale(String(this))
        : getObjectiveLocale(String(this));
};
String.prototype.replaceLocale = function (replacements) {
    let res = String(this);
    for (const placeholder in replacements) {
        const regex = new RegExp(`\\[${placeholder}\\]`, 'g');
        res = res.replace(regex, replacements[placeholder]);
    }
    return res;
};
String.prototype.capitalize = function () {
    const res = String(this);
    return capitalize(res);
};
String.prototype.capitalizeSentences = function () {
    const text = String(this);
    return text.replace(/(^\s*|[.!?]\s+)([a-z])/g, (match, prefix, char) => {
        return prefix + char.toUpperCase();
    });
};
String.prototype.startCase = function () {
    const res = String(this);
    return startCase(res);
};
const EXCEPTIONS = ['and'];
String.prototype.capitalizeWithExceptions = function (exceptions = EXCEPTIONS) {
    const text = String(this);
    if (!text)
        return '';
    return text
        .split(' ')
        .map((word, index) => {
        const lower = word.toLowerCase();
        if (index !== 0 && exceptions.includes(lower)) {
            return lower;
        }
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
        .join(' ');
};
String.prototype.replaceElementLocale = function (replaceTargetObj) {
    let localedText = String(this);
    const SEPARATOR = '~|~';
    replaceTargetObj.forEach((target) => {
        if (!target.identifier || !target.replacementElement)
            return;
        const indexPos = localedText.indexOf(target.identifier);
        if (localedText.indexOf(target.identifier) > -1) {
            const textarr = localedText.split('');
            textarr.splice(indexPos + target.identifier.length, 0, SEPARATOR);
            textarr.splice(indexPos, 0, SEPARATOR);
            localedText = textarr.join('');
        }
    });
    return localedText.split(SEPARATOR).map((element) => {
        const targetIndex = replaceTargetObj.findIndex((target) => target?.identifier == element);
        if (targetIndex < 0)
            return element;
        return replaceTargetObj[targetIndex].replacementElement;
    });
};
String.prototype.replaceBracketWithElement = function (replacementElement) {
    const localedText = String(this);
    return (localedText
        // eslint-disable-next-line no-useless-escape
        .split(/\[([^\[\]]+)\]/g)
        .map((part, index) => (index % 2 == 1 ? replacementElement(part) : part)));
};
String.prototype.parseMessageToTitleAndDescription = function () {
    const res = String(this);
    const firstPeriodIndex = res.indexOf('.');
    if (firstPeriodIndex === -1) {
        return {
            title: '',
            description: res
        };
    }
    return {
        title: res.slice(0, firstPeriodIndex + 1).trim(),
        description: res.slice(firstPeriodIndex + 1).trim()
    };
};
export const pluralize = (word, count, usingBracket) => {
    if (count <= 1)
        return word;
    // Check for special "y" rule
    if (word.endsWith('y') && !/[aeiou]y$/.test(word)) {
        return word.slice(0, -1) + 'ies';
    }
    // Add "(s)" if usingBracket is true, otherwise add "s"
    if (usingBracket) {
        return word + '(s)';
    }
    return word + 's';
};
